import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StaticContentRoutingModule } from './static-content-routing.module';
import { StaticContentComponent } from './static-content.component';

import { MaterialModule } from '../../shared/modules/material.module';
import { AemComponent } from './aem/aem.component';
import { MobileComponent } from './mobile/mobile.component';
import { ProductCatlogComponent } from './product-catlog/product-catlog.component';
// import { SanitizeHtmlPipe } from '../../shared/pipes/sanitize-html.pipe';
import { CmsService } from "../../core/services/cms.service";
import { ProductSearchUnauthComponent } from '../products/product-search-unauth/product-search-unauth.component';
import { ProductCatalogListComponent } from '../products/product-catalog-list/product-catalog-list.component';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { DirectiveModule } from '../../shared/modules/directive.module';
@NgModule({
    imports: [
        CommonModule,
        StaticContentRoutingModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        DirectiveModule
    ],
    declarations: [StaticContentComponent, AemComponent, MobileComponent, ProductCatlogComponent,
        ProductCatalogListComponent,
        ProductSearchUnauthComponent],
    providers: [CmsService]
})
export class StaticContentModule {}
